<template>
  <div class="ypo-event-sort relative-position">
    <v-expansion-panel
      :expand="true"
      class="ypo-event-sort__accordion"
      :value="0">
      <v-expansion-panel-content>
        <div slot="header"  :data-qe-id="`ypo-event-sort__header`">
        {{ selectedSortState.label }}
        </div>
        <div>
          <v-layout
            column
            wrap
            v-for="(sortOption, idx) in ypoEventConstant.sortOptions"
            :key="idx">
            <v-flex xs12 ml-3 class="ypo-event-sort__sort">
              <label class="check-container check-container--radio">
                <v-layout>
                  <v-flex
                    class="check-container--label"
                    :data-qe-id="`ypo-event-sort-option-${idx}`">
                    <span :class="[sortOption.key === selectedSortState.key ? 'bold-font' : '']" slot="label">
                        {{sortOption.label}}</span>
                  </v-flex>
                </v-layout>
                <input
                  class="ypo-event-sort__sort--option"
                  v-model="localSortState"
                  type="radio"
                  :value="sortOption"
                  @change="applySort(sortOption)"
                  :data-qe-id="`ypo-event-sort-option-${idx}_input`">
                <span class="checkmark" :class="[sortOption.key === selectedSortState.key ? 'checked-checkbox' : '']" ></span>
              </label>
            </v-flex>
          </v-layout>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>

import { ypoEventConstant } from "@/components/YpoEvents/ypoEvents.constant";

export default {
  name: "YpoEventsSortBy",  
  data() {
    return {
      ypoEventConstant,
      localSortState: [],
    };
  },
  props: {
    selectedSortState: {
      type: Object,
      required: true,
    },    
  },
  methods: {    
    applySort(sortOption) {       
      if (sortOption) {
        this.$router.push({
        query: {
          ...this.$route.query,
          sortOrder: JSON.stringify(sortOption),
        },
      });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.ypo-event-sort {
  padding-right: 15px;
  &__accordion {
    box-shadow: none !important;    
  }
  &__sort {
    @extend %ypo-secondary-checkbox;
  }
}
</style>
<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.ypo-event-sort {
  &__accordion {
    .v-expansion-panel__header {
      padding: 7px 5px !important;
      min-height: 30px !important;
      font-size: 12px;
      color: $ypo-cod-gray;
      text-transform: uppercase;
      letter-spacing: 0;
      line-height: 17px;
      :hover{
        text-decoration: underline;
      }

      > div {
        flex: 0 1 auto !important;
      }

      &__icon {
        margin-top: 2px;
        margin-left: 5px;  
        text-decoration: none !important; 
        i {
          font-size: 18px;  
          text-decoration: none !important;           
        }
      }
    }       

    .v-expansion-panel__container {
      border-top: 1px solid $ypo-solitude-gray !important;
      border-bottom: 1px solid $ypo-solitude-gray;
      margin-bottom: -1px;

      &--active {
        border-top: 1px solid $ypo-tower-gray-border !important; 
        border-bottom: 1px solid $ypo-tower-gray-border !important;
        z-index: 2;

        .v-expansion-panel__header {
          font-weight: bold !important;
          color: $ypo-cod-gray !important;
        }        
      }
    }    
  }
  &__sort {
    line-height: 17px;
    :hover{
        text-decoration: underline;        
        transition-property: all;
        transition-duration: 200ms;  
        color: $ypo-cod-gray !important;
      }    
  }
  .checkmark{
  border: 1px solid #111111 !important;
  box-shadow: inset 1px 1px 3px 0 rgba(0,0,0,0.3) !important;
  &::after {
    border: none !important;
    -webkit-transform: none !important;
    transform: none !important;
    background-color: $ypo-cod-gray !important;
  }  
  }  
}
</style>

